import { generate } from '@/utils/request';
const config = {
  prefix: '/iam',
  items: [
    // 列表查询
    { key: 'getList', url: '/skyer/v1/{organizationId}/usernotify/list', method: 'POST' },
    // 通知详情
    { key: 'getItemDetail', url: '/skyer/v1/{organizationId}/usernotify/details/{id}', method: 'GET' },
    // 新增通知/新增保存草稿
    { key: 'addNtf', url: '/skyer/v1/{organizationId}/usernotify/add', method: 'POST' },
    // 修改通知/修改保存草稿
    { key: 'updateNtf', url: '/skyer/v1/{organizationId}/usernotify/update', method: 'POST' },
    // 删除
    { key: 'delNtf', url: '/skyer/v1/{organizationId}/usernotify/deletd/{id}', method: 'GET' },
    // 修改状态
    { key: 'changeStatue', url: '/skyer/v1/{organizationId}/usernotify/update/status', method: 'POST' },
    // 是否阅读最新通知
    { key: 'isRead', url: '/skyer/v1/{organizationId}/usernotify/userIsReadNotify', method: 'GET',loadingHide: true },
    // 阅读最新通知
    { key: 'readLast', url: '/skyer/v1/{organizationId}/usernotify/ReadNotify/{id}', method: 'GET' },
  ]
};

export default {
  ...generate(config),
};
